import KLineEChartsTooltipController from './KLineEChartsTooltip';
import dataFormat from './common/dataFormat';

/**
 * KLineTooltipController类定义
 */
class KLineTooltipController extends KLineEChartsTooltipController {
    /**
     * 生成第0块tooltip内容
     * @returns {String} 返回生成的tooltip内容
     */
    generateZeroContent() {
        let content = '';

        let price = this.getPriceTooltip();
        let changeRange = this.getChangeRangeTooltip();
        if (price && changeRange) {
            content += `时间:${price.dateString} 开:${price.open} 高:${price.highest} 低:${price.lowest} 收:${price.close}
                        涨幅:${changeRange.changeRange}% 振幅:${changeRange.amplitude}%`;
        }

        // 如果设置series0（也就是K线）的tooltip.show为false，会导致绑在上面的markPoint也没有tooltip了，所以在显示的时候排除它
        let seriesGroup = this.getGridTooltipByIndex(0, [0]);
        seriesGroup.forEach(series => {
            content += ` ${series.name}:${series.value}`;
        });

        return content;
    }

    /**
     * 生成第1块tooltip内容
     * @returns {String} 返回生成的tooltip内容
     */
    generateFirstContent() {
        let content = '';
        let markPoints = this.getMarkPointTooltip();
        markPoints.forEach(markPoint => {
            let price = dataFormat.numberFormatLogic(markPoint.price);
            let count = dataFormat.volumeFormatLogic(markPoint.count);
            content += ` ${markPoint.name}:${price} 数量:${count}`;
        });
        return content;
    }

    /**
     * 生成第2块tooltip内容
     * @returns {String} 返回生成的tooltip内容
     */
    generateSecondContent() {
        let content = '';
        let seriesGroups = this.getGridTooltipByIndex(1);
        if (seriesGroups[0]) {
            content = '量:' + dataFormat.volumeFormatLogic(seriesGroups[0].value);
        }
        return content;
    }

    /**
     * 生成第3块tooltip内容
     * @returns {String} 返回生成的tooltip内容
     */
    generateThirdContent() {
        let content = '';
        let seriesGroup = this.getGridTooltipByIndex(2);
        seriesGroup.forEach(series => {
            content += ` ${series.name}:${dataFormat.volumeFormatLogic(Math.abs(series.value))}`;
        });
        return content;
    }

    /**
     * 生成第4块tooltip内容
     * @returns {String} 返回生成的tooltip内容
     */
    generateFourthContent() {
        let content = '';
        let seriesGroup = this.getGridTooltipByIndex(3);
        seriesGroup.forEach(series => {
            content += ` ${series.name}:${series.value}`;
        });
        return content;
    }
}

export default KLineTooltipController;



// WEBPACK FOOTER //
// ./src/controller/KLineTooltip.js